<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav title="NUT" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="">
					<div>
						<span class="text-44 text-white">{{$t('NUT.奖励池.资金池总览')}}</span>
					</div>
					<div class="mt-10">
						<span class="text-26 text-#ccc">{{$t('NUT.奖励池.实时监控三大资金池运作状态')}}</span>
					</div>
				</div>
				<div class="mt-20 destroy-team-item1-bg-image rounded-20 p-30">
					<div class="flex items-center justify-center">
						<span class="text-28 text-#999">{{$t('NUT.奖励池.资金池总价值')}}</span>
					</div>
					<div class="text-center mt-10">
						<span class="text-60 font-bold text-white">7,000,000</span>
						<span class="text-40 font-bold text-white">ROON</span>
					</div>
					<div class="mt-30 flex items-center justify-between">
						<div class="rounded-20 p-30 flex-1 mr-10" style="background-color: #2D2D2F;">
							<div class="text-center">
								<span class="text-20 text-white">{{$t('NUT.奖励池.24小时注入')}}</span>
							</div>
							<div class="pt-20 text-center">
								<span class="text-36 text-success font-bold">+37,000</span>
							</div>
						</div>
						<div class="rounded-20 p-30 flex-1 mr-10" style="background-color: #2D2D2F;">
							<div class="text-center">
								<span class="text-20 text-white">{{$t('NUT.奖励池.24小时分配')}}</span>
							</div>
							<div class="pt-20 text-center">
								<span class="text-36 text-success font-bold" style="color: #60A5FB;">+37,000</span>
							</div>
						</div>
						<div class="rounded-20 p-30 flex-1 mr-10" style="background-color: #2D2D2F;">
							<div class="text-center">
								<span class="text-20 text-white">{{$t('NUT.奖励池.24小时销毁')}}</span>
							</div>
							<div class="pt-20 text-center">
								<span class="text-36 text-success font-bold" style="color: #FF983C;">-7,800</span>
							</div>
						</div>
					</div>
				</div>
				<div class=" my-30 flex items-center justify-between rounded-22 h-90 bg-white/10">
					<div @click="setQueryInfo(1)" :class="[queryInfo.type == 1 ? 'bg-primary' : '']"
						class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('NUT.奖励池.LP池')}}</span>
					</div>
					<div @click="setQueryInfo(2)" :class="[queryInfo.type == 2 ? 'bg-primary' : '']"
						class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('NUT.奖励池.质押池')}}</span>
					</div>
					<div @click="setQueryInfo(3)" :class="[queryInfo.type == 3 ? 'bg-primary' : '']"
						class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('NUT.奖励池.税收池')}}</span>
					</div>
				</div>
				<!-- LP池 -->
				<div v-if="queryInfo.type == 1" class="">
					<div class="bg-white/10 rounded-20 p-30">
						<div class="flex items-center justify-between">
							<img class="w-76 h-76" src="@/assets/images/pages/nut-reward-pool/ldxc.png" alt="" />
							<div class="ml-20 flex-1">
								<div>
									<span class="text-36 text-white">{{$t('NUT.奖励池.LP池流动性池')}}</span>
								</div>
								<div>
									<span class="text-24 text-white">35%</span>
								</div>
							</div>
							<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
								style="border-color:#50B428; background-color: #50B42820;">
								<span class="text-20 text-white">{{$t('NUT.奖励池.运行中')}}</span>
							</div>
						</div>
						<div class="mt-20 px-20 h-60 rounded-12 flex items-center  px-20 border border-solid"
							style="border-color:#EB470C; background-color: #EB470C20;">
							<img class="w-24 h-24" src="@/assets/images/pages/nut-reward-pool/th.png" alt="" />
							<span class="ml-20 text-20 text-primary">{{$t('NUT.奖励池.交易手续费的35%注入LP池，增强流动性')}}</span>
						</div>
						<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
							<div class=" flex items-center">
								<span class="text-26 text-white">{{$t('NUT.奖励池.池子总价值')}}</span>
							</div>
							<div class="mt-20">
								<span class="text-44 text-white font-bold">2,450,000 ROON</span>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
								<div class="flex items-center">
									<span class="text-26 text-white">{{$t('NUT.奖励池.今日注入')}}</span>
								</div>
								<div class="mt-20">
									<span class="text-40 text-white font-bold">+1,245.2</span>
								</div>
							</div>
							<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
								<div class=" flex items-center">
									<span class="text-26 text-white">{{$t('NUT.奖励池.累计注入')}}</span>
								</div>
								<div class="mt-20">
									<span class="text-40 text-white font-bold">2,450,000</span>
								</div>
							</div>
						</div>
						<div class="h-100 rounded-20 p-30 flex items-center justify-between mt-20"
							style="background-color: #0F0F10;">
							<div class="flex items-center">
								<span class="text-26 text-white">{{$t('NUT.奖励池.累计注入')}}</span>
							</div>
							<div class="mt-20">
								<span class="text-40 text-white font-bold">2,450,000 ROON</span>
							</div>
						</div>
						<div @click="seeData(1)" class="mt-30 px-20 h-100 rounded-full flex items-center justify-center"
							style="background-color: #EB470C20;">
							<span class="text-32 text-primary">{{$t('NUT.奖励池.查看详细数据')}}</span>
						</div>
					</div>
					<div class="mt-30 bg-white/10 rounded-20 p-30">
						<div class="flex items-center justify-between pb-20 border-b border-b-solid"
							style="border-bottom-color: #2D2D2E;">
							<span class="text-white text-36">{{$t('NUT.奖励池.操作记录')}}</span>
							<div class="flex items-center">
								<span class="text-white text-20">{{$t('NUT.奖励池.查看全部')}}</span>
								<img class="ml-10 w-24 h-24" src="@/assets/images/pages/nut-reward-pool/more.png"
									alt="" />
							</div>
						</div>
						<div v-for="(item, index) in 3" :key="index" class="h-150 border-b border-b-solid py-20"
							style="border-bottom-color: #2D2D2E;">
							<div class="flex items-center">
								<div class="px-20 rounded-full px-20" style="background-color: #23422F;">
									<span class="text-20 text-success">{{$t('NUT.奖励池.注入')}}</span>
								</div>
								<div class="ml-20">
									<span class="text-40 text-success font-bold">+2,450 ROON</span>
								</div>
							</div>
							<div class="mt-20 flex items-center justify-between">
								<span class="text-24 text-#ccc">2025-12-06 14:00</span>
								<span class="text-24 text-#ccc">0x7a8b...3c4d</span>
							</div>
						</div>
						<div class="flex items-center justify-center py-50 ">
							<span class="text-20 text-white">{{$t('NUT.奖励池.加载更多')}}</span>
							<img class="ml-10 w-20 h-20" src="@/assets/images/pages/nut-reward-pool/jz.png" alt="" />
						</div>
					</div>
				</div>
				<!-- 质押奖励池 -->
				<div v-else-if="queryInfo.type == 2" class="">
					<div class="bg-white/10 rounded-20 p-30">
						<div class="flex items-center justify-between">
							<img class="w-76 h-76" src="@/assets/images/pages/nut-reward-pool/jlc.png" alt="" />
							<div class="ml-20 flex-1">
								<div>
									<span class="text-36 text-white">{{$t('NUT.奖励池.质押奖励池')}}</span>
								</div>
								<div>
									<span class="text-24 text-white">25%</span>
								</div>
							</div>
							<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
								style="border-color:#50B428; background-color: #50B42820;">
								<span class="text-20 text-white">{{$t('NUT.奖励池.运行中')}}</span>
							</div>
						</div>
						<div class="mt-20 px-20 h-60 rounded-12 flex items-center  px-20 border border-solid"
							style="border-color:#EB470C; background-color: #EB470C20;">
							<img class="w-24 h-24" src="@/assets/images/pages/nut-reward-pool/th.png" alt="" />
							<span class="ml-20 text-20 text-primary">{{$t('NUT.奖励池.交易手续费的25%用于质押奖励分配')}}</span>
						</div>
						<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
							<div class=" flex items-center">
								<span class="text-26 text-white">{{$t('NUT.奖励池.池子总价值')}}</span>
							</div>
							<div class="mt-20">
								<span class="text-44 text-white font-bold">2,450,000 ROON</span>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
								<div class="flex items-center">
									<span class="text-26 text-white">{{$t('NUT.奖励池.今日注入')}}</span>
								</div>
								<div class="mt-20">
									<span class="text-40 text-white font-bold">+1,245.2</span>
								</div>
							</div>
							<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
								<div class=" flex items-center">
									<span class="text-26 text-white">{{$t('NUT.奖励池.累计分配')}}</span>
								</div>
								<div class="mt-20">
									<span class="text-40 text-white font-bold">2,450,000</span>
								</div>
							</div>
						</div>
						<div class="h-100 rounded-20 p-30 flex items-center justify-between mt-20"
							style="background-color: #0F0F10;">
							<div class="flex items-center">
								<span class="text-26 text-white">{{$t('NUT.奖励池.累计注入')}}</span>
							</div>
							<div class="mt-20">
								<span class="text-40 text-white font-bold">2,450,000 ROON</span>
							</div>
						</div>
						<div @click="seeData(2)" class="mt-30 px-20 h-100 rounded-full flex items-center justify-center"
							style="background-color: #EB470C20;">
							<span class="text-32 text-primary">{{$t('NUT.奖励池.查看详细数据')}}</span>
						</div>
					</div>
					<div class="mt-30 bg-white/10 rounded-20 p-30">
						<div class="flex items-center justify-between pb-20 border-b border-b-solid"
							style="border-bottom-color: #2D2D2E;">
							<span class="text-white text-36">{{$t('NUT.奖励池.操作记录')}}</span>
							<div class="flex items-center">
								<span class="text-white text-20">{{$t('NUT.奖励池.查看全部')}}</span>
								<img class="ml-10 w-24 h-24" src="@/assets/images/pages/nut-reward-pool/more.png"
									alt="" />
							</div>
						</div>
						<div v-for="(item, index) in 3" :key="index" class="h-150 border-b border-b-solid py-20"
							style="border-bottom-color: #2D2D2E;">
							<div class="flex items-center">
								<div v-if="index == 1" class="px-20 rounded-full px-20"
									style="background-color: #23422F;">
									<span class="text-20 text-success">{{$t('NUT.奖励池.注入')}}</span>
								</div>
								<div v-else class="px-20 rounded-full px-20" style="background-color: #299EE820;">
									<span class="text-20 text-success"
										style="color:#299EE8;">{{$t('NUT.奖励池.分配')}}</span>
								</div>
								<div class="ml-20">
									<span class="text-40 text-success font-bold">+2,450 ROON</span>
								</div>
							</div>
							<div class="mt-20 flex items-center justify-between">
								<span class="text-24 text-#ccc">2025-12-06 14:00</span>
								<span class="text-24 text-#ccc">0x7a8b...3c4d</span>
							</div>
						</div>
						<div class="flex items-center justify-center py-50 ">
							<span class="text-20 text-white">{{$t('NUT.奖励池.加载更多')}}</span>
							<img class="ml-10 w-20 h-20" src="@/assets/images/pages/nut-reward-pool/jz.png" alt="" />
						</div>
					</div>
				</div>
				<!-- 税收回购池 -->
				<div v-else-if="queryInfo.type == 3" class="">
					<div class="bg-white/10 rounded-20 p-30">
						<div class="flex items-center justify-between">
							<img class="w-76 h-76" src="@/assets/images/pages/nut-reward-pool/hgc.png" alt="" />
							<div class="ml-20 flex-1">
								<div>
									<span class="text-36 text-white">{{$t('NUT.奖励池.税收回购池')}}</span>
								</div>
								<div>
									<span class="text-24 text-white">40%</span>
								</div>
							</div>
							<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
								style="border-color:#50B428; background-color: #50B42820;">
								<span class="text-20 text-white">{{$t('NUT.奖励池.运行中')}}</span>
							</div>
						</div>
						<div class="mt-20 px-20 h-60 rounded-12 flex items-center px-20 border border-solid"
							style="border-color:#EB470C; background-color: #EB470C20;">
							<img class="w-24 h-24" src="@/assets/images/pages/nut-reward-pool/th.png" alt="" />
							<span class="ml-20 text-20 text-primary">{{$t('NUT.奖励池.交易手续费的40%用于税收回购和销毁')}}</span>
						</div>
						<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
							<div class=" flex items-center">
								<span class="text-26 text-white">{{$t('NUT.奖励池.池子总价值')}}</span>
							</div>
							<div class="mt-20">
								<span class="text-44 text-white font-bold">2,450,000 ROON</span>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
								<div class="flex items-center">
									<span class="text-26 text-white">{{$t('NUT.奖励池.今日回购')}}</span>
								</div>
								<div class="mt-20">
									<span class="text-40 text-white font-bold">+1,245.2</span>
								</div>
							</div>
							<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
								<div class=" flex items-center">
									<span class="text-26 text-white">{{$t('NUT.奖励池.累计销毁')}}</span>
								</div>
								<div class="mt-20">
									<span class="text-40 text-white font-bold">2,450,000</span>
								</div>
							</div>
						</div>
						<div class="h-100 rounded-20 p-30 flex items-center justify-between mt-20"
							style="background-color: #0F0F10;">
							<div class="flex items-center">
								<span class="text-26 text-white">{{$t('NUT.奖励池.累计销毁')}}</span>
							</div>
							<div class="mt-20">
								<span class="text-40 text-white font-bold">2,450,000 ROON</span>
							</div>
						</div>
						<div @click="seeData(3)" class="mt-30 px-20 h-100 rounded-full flex items-center justify-center"
							style="background-color: #EB470C20;">
							<span class="text-32 text-primary">{{$t('NUT.奖励池.查看详细数据')}}</span>
						</div>
					</div>
					<div class="mt-30 bg-white/10 rounded-20 p-30">
						<div class="flex items-center justify-between pb-20 border-b border-b-solid"
							style="border-bottom-color: #2D2D2E;">
							<span class="text-white text-36">{{$t('NUT.奖励池.操作记录')}}</span>
							<div class="flex items-center">
								<span class="text-white text-20">{{$t('NUT.奖励池.查看全部')}}</span>
								<img class="ml-10 w-24 h-24" src="@/assets/images/pages/nut-reward-pool/more.png"
									alt="" />
							</div>
						</div>
						<div v-for="(item, index) in 3" :key="index" class="h-150 border-b border-b-solid py-20"
							style="border-bottom-color: #2D2D2E;">
							<div class="flex items-center">
								<div v-if="index == 1" class="px-20 rounded-full px-20"
									style="background-color: #A229E820;">
									<span class="text-20 text-success" style="color: #A229E8;">{{$t('NUT.奖励池.回购')}}</span>
								</div>
								<div v-else class="px-20 rounded-full px-20" style="background-color: #E8292920;">
									<span class="text-20 text-success"
										style="color:#E82929;">{{$t('NUT.奖励池.销毁')}}</span>
								</div>
								<div class="ml-20">
									<span class="text-40 text-success font-bold">+2,450 ROON</span>
								</div>
							</div>
							<div class="mt-20 flex items-center justify-between">
								<span class="text-24 text-#ccc">2025-12-06 14:00</span>
								<span class="text-24 text-#ccc">0x7a8b...3c4d</span>
							</div>
						</div>
						<div class="flex items-center justify-center py-50 ">
							<span class="text-20 text-white">{{$t('NUT.奖励池.加载更多')}}</span>
							<img class="ml-10 w-20 h-20" src="@/assets/images/pages/nut-reward-pool/jz.png" alt="" />
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<menu-bar-nut activeMenu="nut-reward-pool"></menu-bar-nut>
		</template>
		<template v-slot:popup>
			<van-popup v-model="showAmountPopup" position="center" round>
				<div class="w-690">
					<div class="bg-#19191A rounded-20 w-690 relative pt-100 pb-30 px-30" style="margin-top: -98rem;">
						<div class="flex items-start justify-between mt-20">
							<!-- LP流动性池 -->
							<div v-if="popupType == 1" class="flex items-center">
								<img class="w-76 h-76" src="@/assets/images/pages/nut-reward-pool/ldxc.png" alt="" />
								<div class="ml-20">
									<div>
										<span class="text-36 text-white">{{$t("NUT.奖励池.LP流动性池")}}</span>
									</div>
									<div>
										<span class="text-26 text-#999">{{$t("NUT.奖励池.详细数据分析")}}</span>
									</div>
								</div>
							</div>
							<!-- 质押奖励池 -->
							<div v-else-if="popupType == 2" class="flex items-center">
								<img class="w-76 h-76" src="@/assets/images/pages/nut-reward-pool/jlc.png" alt="" />
								<div class="ml-20">
									<div>
										<span class="text-36 text-white">{{$t("NUT.奖励池.质押奖励池")}}</span>
									</div>
									<div>
										<span class="text-26 text-#999">{{$t("NUT.奖励池.详细数据分析")}}</span>
									</div>
								</div>
							</div>
							<!-- 税收回购池 -->
							<div v-else-if="popupType == 3" class="flex items-center">
								<img class="w-76 h-76" src="@/assets/images/pages/nut-reward-pool/hgc.png" alt="" />
								<div class="ml-20">
									<div>
										<span class="text-36 text-white">{{$t("NUT.奖励池.税收回购池")}}</span>
									</div>
									<div>
										<span class="text-26 text-#999">{{$t("NUT.奖励池.详细数据分析")}}</span>
									</div>
								</div>
							</div>
							<img @click="showAmountPopup = false" class="w-40 h-40"
								src="@/assets/images/pages/usdr-swap/icon_gb.png" alt="" />
						</div>
						<div class=" my-30 flex items-center justify-between rounded-22 h-90 bg-white/10">
							<div @click="setPopupQueryInfo(1)" :class="[popupQueryInfo.type == 1 ? 'bg-primary' : '']"
								class="rounded-22 flex-1 h-90 flex items-center justify-center">
								<span class="text-32 text-white">{{$t('NUT.奖励池.概览')}}</span>
							</div>
							<div @click="setPopupQueryInfo(2)" :class="[popupQueryInfo.type == 2 ? 'bg-primary' : '']"
								class="rounded-22 flex-1 h-90 flex items-center justify-center">
								<span class="text-32 text-white">{{$t('NUT.奖励池.图表')}}</span>
							</div>
							<div @click="setPopupQueryInfo(3)" :class="[popupQueryInfo.type == 3 ? 'bg-primary' : '']"
								class="rounded-22 flex-1 h-90 flex items-center justify-center">
								<span class="text-32 text-white">{{$t('NUT.奖励池.记录')}}</span>
							</div>
						</div>
						<!-- 概览 -->
						<div v-if="popupQueryInfo.type == 1" class="">
							<!-- LP流动性池 -->
							<div v-if="popupType == 1" class="">
								<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
									<div class=" flex items-center">
										<span class="text-26 text-#ccc">{{$t('NUT.奖励池.池子总价值')}}</span>
									</div>
									<div class="mt-20">
										<span class="text-44 text-white font-bold">$3,500,000</span>
									</div>
									<div class="mt-20">
										<span class="text-28 text-primary">{{$t('NUT.奖励池.占比')}}35%</span>
									</div>
								</div>
								<div class="mt-20 flex items-center justify-between">
									<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
										<div class="flex items-center">
											<span class="text-26 text-#ccc">NUT{{$t('NUT.奖励池.数量')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">1,750,000,000</span>
										</div>
									</div>
									<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
										<div class=" flex items-center">
											<span class="text-26 text-#ccc">ROON{{$t('NUT.奖励池.数量')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">875,000</span>
										</div>
									</div>
								</div>
								<div class="mt-20 flex items-center justify-between">
									<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
										<div class="flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.LP代币')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">125,000</span>
										</div>
									</div>
									<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
										<div class=" flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.持有人数')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">875,000</span>
										</div>
									</div>
								</div>
								<div class="mt-20 flex items-center justify-between">
									<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
										<div class="flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.年华收益')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">156.8%</span>
										</div>
									</div>
									<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
										<div class=" flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.日奖励')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">875,000</span>
										</div>
									</div>
								</div>
							</div>
							<!-- 质押奖励池 -->
							<div v-else-if="popupType == 2" class="">
								<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
									<div class=" flex items-center">
										<span class="text-26 text-#ccc">{{$t('NUT.奖励池.池子总价值')}}</span>
									</div>
									<div class="mt-20">
										<span class="text-44 text-white font-bold">$3,500,000</span>
									</div>
									<div class="mt-20">
										<span class="text-28 text-primary">{{$t('NUT.奖励池.占比')}}25%</span>
									</div>
								</div>
								<div class="mt-20 flex items-center justify-between">
									<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
										<div class="flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.总质押量')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">25,000,000,000</span>
										</div>
									</div>
									<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
										<div class=" flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.质押人数')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">1 523</span>
										</div>
									</div>
								</div>
								<div class="mt-20 flex items-center justify-between">
									<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
										<div class="flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.平均质押')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">16,414,000</span>
										</div>
									</div>
									<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
										<div class=" flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.待领奖励')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">125,000</span>
										</div>
									</div>
								</div>
								<div class="mt-20 flex items-center justify-between">
									<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
										<div class="flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.年华收益')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">89.5%</span>
										</div>
									</div>
									<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
										<div class=" flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.日奖励')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">32,000</span>
										</div>
									</div>
								</div>
							</div>
							<!-- 税收回购池 -->
							<div v-else-if="popupType == 3" class="">
								<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
									<div class=" flex items-center">
										<span class="text-26 text-#ccc">{{$t('NUT.奖励池.池子总价值')}}</span>
									</div>
									<div class="mt-20">
										<span class="text-44 text-white font-bold">$3,500,000</span>
									</div>
									<div class="mt-20">
										<span class="text-28 text-primary">{{$t('NUT.奖励池.占比')}}40%</span>
									</div>
								</div>
								<div class="mt-20 flex items-center justify-between">
									<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
										<div class="flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.盈利税')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">1,200,000</span>
										</div>
									</div>
									<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
										<div class=" flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.砸盘税')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">875,000</span>
										</div>
									</div>
								</div>
								<div class="mt-20 flex items-center justify-between">
									<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
										<div class="flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.回购总额')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">125,000</span>
										</div>
									</div>
									<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
										<div class=" flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.销毁总额')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">875,000</span>
										</div>
									</div>
								</div>
								<div class="mt-20 flex items-center justify-between">
									<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
										<div class="flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.分配总额')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">156.8%</span>
										</div>
									</div>
									<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
										<div class=" flex items-center">
											<span class="text-26 text-#ccc">{{$t('NUT.奖励池.日回购')}}</span>
										</div>
										<div class="mt-20">
											<span class="text-36 text-white font-bold">875,000</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- 图表 -->
						<div v-else-if="popupQueryInfo.type == 2" class="">
							<div class="">
								<span class="text-30 text-white">{{$t('NUT.奖励池.7日资金流动趋势')}}</span>
							</div>
							<div class="mt-20 rounded-20 h-340" style="background-color: #0F0F10;"></div>
							<div class="mt-20">
								<span class="text-30 text-white">{{$t('NUT.奖励池.资金分配占比')}}</span>
							</div>
							<div class="mt-20 rounded-20 h-340" style="background-color: #0F0F10;"></div>
						</div>
						<!-- 记录 -->
						<div v-else-if="popupQueryInfo.type == 3" class="">
							<div class="h-600 overflow-y-scroll">
								<div v-for="(item, index) in 10" :key="index" class="mb-20 rounded-20 h-146 p-20"
									style="background-color: #0F0F10;">
									<div class="flex items-center justify-between">
										<div v-if="index == 1" class="px-20 rounded-full px-20"
											style="background-color: #23422F;">
											<span class="text-20 text-success">{{$t('NUT.奖励池.注入')}}</span>
										</div>
										<div v-else-if="index == 2" class="px-20 rounded-full px-20"
											style="background-color: #A229E820;">
											<span class="text-20 text-success"
												style="color: #A229E8;">{{$t('NUT.奖励池.回购')}}</span>
										</div>
										<div v-else-if="index == 3" class="px-20 rounded-full px-20"
											style="background-color: #E8292920;">
											<span class="text-20 text-success"
												style="color: #E82929;">{{$t('NUT.奖励池.销毁')}}</span>
										</div>
										<div v-else class="px-20 rounded-full px-20"
											style="background-color:#299EE820;">
											<span class="text-20 text-success"
												style="color: #299EE8;">{{$t('NUT.奖励池.分配')}}</span>
										</div>
										<span v-if="index ==3" class="text-danger text-40">+2,450 ROON</span>
										<span v-else class="text-success text-40">+2,450 ROON</span>
									</div>
									<div class="mt-20 flex items-center justify-between">
										<span class="text-24 text-#ccc">2025-12-06 14:00</span>
										<span class="text-24 text-#ccc">0x7a8b...3c4d</span>
									</div>
								</div>
								<div class="flex items-center justify-center py-50 ">
									<span class="text-20 text-white">{{$t('NUT.奖励池.加载更多')}}</span>
									<img class="ml-10 w-20 h-20" src="@/assets/images/pages/nut-reward-pool/jz.png"
										alt="" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-popup>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBarNut from '@/components/menu-bar-nut/menu-bar-nut.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBarNut,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
				queryInfo: {
					page: 1,
					type: 3
				},
				form: {
					type: 1,
					amount: 0,
					dd_roon: 0,
					amount_id: 0
				},
				numberList: [{
						id: 1,
						num: 0.1
					},
					{
						id: 2,
						num: 0.5
					},
					{
						id: 3,
						num: 1.0
					},
				],
				// 弹窗类型
				popupType: 1,
				showAmountPopup: false,
				popupQueryInfo: {
					page: 1,
					type: 1
				}
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
		},
		created() {},
		methods: {
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			seeData(number) {
				this.popupType = number;
				this.showAmountPopup = true;
			},
			setPopupQueryInfo(type) {
				this.popupQueryInfo.type = type;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.destroy-team-item1-bg-image {
		width: 690rem;
		height: 360rem;
		background-image: url("~@/assets/images/pages/destroy-team/itemBg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}
</style>